import { motion } from "framer-motion";
import { Gamepad2, Sparkles } from "lucide-react";

const GAME_URL = "https://shutthebox.io/alpha_a/index.html";

const CountdownTimer = () => {
  return (
    <div className="relative w-full mx-auto px-2 md:px-4">
      {/* Glassmorphic container */}
      <div className="relative overflow-hidden bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-md rounded-xl md:rounded-2xl shadow-2xl border border-white/20 p-3 lg:p-6">
        {/* Animated gradient background */}
        <div className="absolute inset-0 bg-gradient-to-r from-pink-500/10 via-purple-500/10 to-yellow-500/10 opacity-50 blur-xl" />

        {/* Pulsing glow effect */}
        <div className="absolute -inset-1 bg-gradient-to-r from-pink-500/20 to-yellow-500/20 blur-2xl opacity-75 animate-pulse" />

        {/* Content */}
        <div className="relative z-10 flex justify-center">
          {/* Mobile: Compact button */}
          <a
            href={GAME_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="lg:hidden group relative inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-pink-500 to-yellow-500 hover:from-pink-400 hover:to-yellow-400 rounded-full text-white font-bold text-base shadow-lg transition-all duration-300"
          >
            <Gamepad2 className="w-5 h-5" />
            <span>Play Now</span>
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-pink-500/50 to-yellow-500/50 blur-lg opacity-50 -z-10" />
          </a>

          {/* Desktop: Larger button with animation */}
          <motion.a
            href={GAME_URL}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.2 }}
            className="hidden lg:inline-flex group relative items-center gap-3 px-10 py-4 bg-gradient-to-r from-pink-500 to-yellow-500 hover:from-pink-400 hover:to-yellow-400 rounded-full text-white font-bold text-xl shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
          >
            <Gamepad2 className="w-6 h-6" />
            <span>Play Now</span>
            <Sparkles className="w-5 h-5 opacity-75 group-hover:opacity-100 transition-opacity" />

            {/* Button glow effect */}
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-pink-500/50 to-yellow-500/50 blur-lg opacity-50 group-hover:opacity-75 transition-opacity -z-10" />
          </motion.a>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
